import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_yandex_map_3 = _resolveComponent("yandex-map-3")!

  return (_openBlock(), _createBlock(_component_yandex_map_3, {
    class: "dispatcher-workplace-map",
    provider: "yandex",
    "provider-script-src": _ctx.YANDEX_MAP_SCRIPT_SRC,
    onMapReady: _ctx.onMapReady,
    onMapDestroyed: _ctx.onMapDestroyed,
    onMapClicked: _ctx.onMapClicked
  }, null, 8, ["provider-script-src", "onMapReady", "onMapDestroyed", "onMapClicked"]))
}